import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=465d5ba6&scoped=true"
import script from "./BranchList.vue?vue&type=script&lang=ts"
export * from "./BranchList.vue?vue&type=script&lang=ts"
import style0 from "./BranchList.vue?vue&type=style&index=0&id=465d5ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d5ba6",
  null
  
)

export default component.exports